import React from 'react';

const Header = () => {
  return (
    <div className="header-placeholder">
      {/* Header simplificado - toda la navegación está en el Sidebar */}
    </div>
  );
};

export default Header;
